import { createContext, useContext } from "react";
import { FOLLOW_UP_SHORT_LABEL } from "shared/app/CallFollowUp";
import type { FollowUpRequestType } from "shared/app/CallFollowUp";

interface OpenFollowUpCall {
  callTranscriptId: number;
  reason: FollowUpRequestType | null;
}

// The AI call in the open thread that is still waiting for a human. The call
// card reads it to draw its red ring; null outside the Inbox thread view.
export const FollowUpCallContext = createContext<OpenFollowUpCall | null>(null);

export const useOpenFollowUpCall = () => useContext(FollowUpCallContext);

export const useCallFollowUpLabel = (
  callTranscriptId: number | string | null | undefined
): string | undefined => {
  const openFollowUpCall = useOpenFollowUpCall();
  if (callTranscriptId == null || !openFollowUpCall) return undefined;
  if (openFollowUpCall.callTranscriptId !== Number(callTranscriptId))
    return undefined;
  if (!openFollowUpCall.reason) return "Needs follow-up";
  return FOLLOW_UP_SHORT_LABEL[openFollowUpCall.reason];
};

export const followUpCallElementId = (callTranscriptId: number) =>
  `inbox-call-transcript-${callTranscriptId}`;
